import React from "react";
// import BannerSeguridadInformacion from "./../../imagenes/tips_de_seguridad.png";

class SeguridadInformacion extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="cta" className="cta">
          <div className="container" data-aos="zoom-in">
            <div className="d-flex flex-column align-items-center">
              {/* <div className="col-12 text-center">
                <img
                  src={BannerSeguridadInformacion}
                  className="w-75 rounded"
                />
              </div> */}
              <video
                id="seguridadVideo"
                src="./videos/Correos_Falsos.MOV"
                controlsList="nodownload noremoteplayback nofullscreen"
                controls
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "400px",
                  borderRadius: "10px",
                  objectFit: "contain",
                }}
              ></video>
              <div className="col-12 text-center">
                <p className="mt-3">
                  <a className="cta-btn align-middle" href="/noticias">
                    Más información
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default SeguridadInformacion;
